import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {
    render() {
        const BankSummarySearchData = this.props.BankSummarySearchData;
        const BankSummaryData = this.props.BankSummaryData;
        const TotalAmount = this.props.TotalAmount;

        const cellStyle = {
            border: '1px solid black',
            padding: '1px',
            fontSize: '0.9rem',
          };
        
        return (
            <div>
                <h2><center>Bank Summary Report</center></h2>
                <div>&nbsp;</div>
                <h3><center>{BankSummarySearchData.groupName} - {BankSummarySearchData.factoryName} - {BankSummarySearchData.routeName}</center></h3>
                <h3><center>{BankSummarySearchData.bankName} - {BankSummarySearchData.branchName}</center></h3>
                <h3><center>{BankSummarySearchData.month} - {BankSummarySearchData.year}</center></h3>
                <div>&nbsp;</div>

                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050} style={{paddingLeft:'10px', paddingRight:'10px'}}>
                        <TableContainer >
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow style={{ border: '1px solid black' }}>
                                        <TableCell align={'left'} style={cellStyle}>Bank</TableCell>
                                        <TableCell align={'left'} style={cellStyle}>Branch</TableCell>
                                        <TableCell align={'right'} style={cellStyle}>Amount(Rs.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {BankSummaryData.map((data, index) => (
                                        <TableRow key={index} style={{ border: '1px solid black' }}>
                                            <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                                                {data.bankName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                                                {data.branchName}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={cellStyle}>
                                                {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow style={{ border: '1px solid black' }}>
                                    <TableCell align={'center'} colSpan={2} style={cellStyle}><b>Total</b></TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={cellStyle}>
                                        <b> {TotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}